const NAMESPACE = "projectSummaryCapsule";

const KEYS = {
    noCellDataBodyText: "noCellDataBodyText",
    cellLoadingHeaderText: "cellLoadingHeaderText",
    cellLoadingBodyText: "cellLoadingBodyText"
};

const MESSAGES = {
    [KEYS.noCellDataBodyText]: {
        value: "None",
        comment: "Text that appears in cells with no data"
    },
    [KEYS.cellLoadingHeaderText]: {
        value: "...",
        comment: "Text that appears as the cell header while it is loading"
    },
    [KEYS.cellLoadingBodyText]: {
        value: "...",
        comment: "Text that appears in the cell body while it is loading"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
